
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  name: "ci-login-modal",
})
export default class extends Vue {
  @Prop({ default: null }) gatingBannerLocation!: Nullable<string>;
  @Prop({ default: null }) onboardingType!: Nullable<string>;
  @Prop({ default: "" }) headline!: string;
  @Prop({ default: "" }) returnButtonText!: string;
  @Prop({ default: "" }) newPasswordUrl!: string;
  @Prop({ default: "" }) formAuthenticityToken!: string;

  public get trackingOnboardingType(): Nullable<string> {
    return this.onboardingType ?? "modal-login-page";
  }

  public closeModal(): void {
    this.$bvModal.hide("modal-login");
  }
}
